module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "opera-center",
    staticStyle: {
      "background-color": "#f7f8fa"
    }
  }, [_c('div', {
    staticClass: "head clearfix",
    staticStyle: {
      "background": "url('./static/images/centerBg.png') center"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/opera/centerInfo"
    }
  }, [_c('div', {
    staticClass: "textImg"
  }, [_c('div', {
    staticClass: "pic"
  }, [(!!_vm.perInfo.pic) ? _c('img', {
    attrs: {
      "src": _vm.perInfo.pic
    }
  }) : _c('img', {
    attrs: {
      "src": require("../../assets/images/tx.png")
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_c('p', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.perInfo.name))])]), _vm._v(" "), _c('i', {
    staticClass: "iconfont icon-you"
  })])])], 1), _vm._v(" "), _c('ul', {
    staticClass: "setOption"
  }, [(_vm.perInfo.rights != null && _vm.perInfo.rights.indexOf('wap!event') >= 0 && !_vm.isHuanQiu) ? _c('mt-cell', {
    attrs: {
      "title": _vm.$t('center_event_warning'),
      "to": "/opera/eventWorm?redirect=/opera/center",
      "is-link": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.bMihotel && !_vm.isHuanQiu) ? _c('li', {
    staticClass: "mint-cell",
    on: {
      "click": function($event) {
        return _vm.openOutUrl()
      }
    }
  }, [_c('span', {
    staticClass: "mint-cell-mask"
  }), _vm._v(" "), _c('div', {
    staticClass: "mint-cell-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "mint-cell-wrapper"
  }, [_c('div', {
    staticClass: "mint-cell-title"
  }, [_c('span', {
    staticClass: "mint-cell-text"
  }, [_vm._v(_vm._s(_vm.$t('center_feedback')))])]), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "mint-cell-right"
  }), _vm._v(" "), _c('i', {
    staticClass: "mint-cell-allow-right"
  })]) : _vm._e(), _vm._v(" "), (_vm.bMihotel) ? _c('li', {
    staticClass: "mint-cell",
    on: {
      "click": _vm.share
    }
  }, [_c('span', {
    staticClass: "mint-cell-mask"
  }), _vm._v(" "), _c('div', {
    staticClass: "mint-cell-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "mint-cell-wrapper"
  }, [_c('div', {
    staticClass: "mint-cell-title"
  }, [_c('span', {
    staticClass: "mint-cell-text"
  }, [_vm._v(_vm._s(_vm.$t('center_share_APP')))])]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('div', {
    staticClass: "mint-cell-right"
  }), _vm._v(" "), _c('i', {
    staticClass: "mint-cell-allow-right"
  })]) : _vm._e(), _vm._v(" "), (!_vm.isHuanQiu) ? _c('mt-cell', {
    attrs: {
      "title": _vm.$t('center_version'),
      "to": "/opera/version",
      "is-link": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.perInfo.code == 'ADMIN') ? _c('mt-cell', {
    attrs: {
      "title": _vm.$t('center_cacheMange'),
      "to": "/opera/cacheMange",
      "is-link": ""
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isHuanQiu) ? _c('mt-cell', {
    attrs: {
      "title": _vm.$t('center_setting'),
      "to": "/opera/setting?redirect=/opera/center",
      "is-link": ""
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.loginOut
    }
  }, [_vm._v(_vm._s(_vm.$t('logout')))]), _vm._v(" "), _c('foot-nav', {
    attrs: {
      "sta": "3"
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mint-cell-value is-link"
  }, [_c('span')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mint-cell-value is-link"
  }, [_c('span')])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-44f1e692","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/operaPage/center.vue
// module id = 1778
// module chunks = 107